import * as yup from 'yup';

const noteSchema = yup.object().shape({});

export default noteSchema;
